<template>
	<nav class="content bg-white-darker-3 padding-vertical-normal overflow-auto">
		<ol v-if="isCollapsed" class="display-flex padding-0 align-items-center margin-0">
			<li class="cursor-pointer white-space-nowrap font-size-normal display-flex">
				<b-router-link routerLinkClassess="ink-base no-decoration" :to="firstItemInList.path">{{
					firstItemInList.name
				}}</b-router-link>
			</li>
			<li
				class="ink-base font-size-normal display-flex cursor-pointer white-space-nowrap"
				@click="handleBreadcrumbsExpansion"
				@keypress="expandsOnEnter"
			>
				...
			</li>
			<li class="cursor-pointer white-space-nowrap font-size-normal display-flex">
				<b-router-link routerLinkClassess="ink-base no-decoration" :to="lastItemInList.path">{{
					lastItemInList.name
				}}</b-router-link>
			</li>
		</ol>

		<ol v-else class="display-flex padding-0 align-items-center margin-0">
			<li
				v-for="(item, key) in list"
				:key="key"
				class="cursor-pointer white-space-nowrap font-size-normal display-flex"
			>
				<b-router-link :to="item.path" routerLinkClassess="ink-base no-decoration">{{
					item.name
				}}</b-router-link>
			</li>
		</ol>
	</nav>
</template>

<script>
import { debounce } from 'lodash';
import BRouterLink from './RouterLink.vue';

export default {
	name: 'b-breadcrumbs',
	components: {
		BRouterLink
	},
	data() {
		return {
			isCollapsed: false,
			resizeObserver: null
		};
	},
	props: {
		/**
		 * Listagem de rotas
		 */
		list: {
			type: Array,
			required: true
		}
	},
	mounted() {
		this.resizeObserver = new ResizeObserver(debounce(this.onResize, 200)).observe(this.$el);
	},
	beforeDestroy() {
		this.resizeObserver.unobserve(this.$el);
	},
	methods: {
		handleBreadcrumbsExpansion() {
			this.isCollapsed = !this.isCollapsed;
		},
		expandsOnEnter(event) {
			if (event.keyCode === 13) this.handleBreadcrumbsExpansion();
		},
		onResize() {
			if (this.isCollapsed !== this.$el.scrollWidth > this.$el.offsetWidth) {
				this.isCollapsed = this.$el.scrollWidth > this.$el.offsetWidth;
			}
		}
	},
	computed: {
		lastItemInList() {
			return this.list[this.list.length - 1] ? this.list[this.list.length - 1] : {};
		},
		firstItemInList() {
			return this.list[0] ? this.list[0] : {};
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../css/spacing.scss';
li:not(:first-child)::before {
	content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41IDcuNzVMNC4yNSA0TDAuNSAwLjI1VjcuNzVaIiBmaWxsPSIjODA3QjkxIi8+Cjwvc3ZnPgo=');
	margin: 0 map-get($spacingSizes, 'normal');
}
</style>

<docs>
    ```js
    <b-breadcrumbs 
		list="[
			{ name: 'Projetos', path: '/projects' },
			{ name: 'Nome do projeto', path: '/projects' },
			{ name: 'Documentos', path: '/projects' },
		]"
	/>
    ```
</docs>
